import { EnumPermissions, IMenuItem, makeRoute } from '@olymp/shared';
import { FeatureRouteEnum } from './feature-routes.enum';
import { ProfileRouteEnum } from './profile/enum/profile-route-enum';

export const menu: IMenuItem[] = [
  // {
  //   label: 'statistics',
  //   icon: 'icon-statistic',
  //   link: '/dashboard',
  // },
  {
    label: 'my_profile',
    icon: 'icon-User',
    children: [
      {
        label: ProfileRouteEnum.CABINET,
        link: makeRoute([FeatureRouteEnum.PROFILE, ProfileRouteEnum.CABINET]),
        exact: true,
      },
      {
        label: ProfileRouteEnum.ADDUSER,
        link: makeRoute([
          FeatureRouteEnum.PROFILE,
          ProfileRouteEnum.CABINET,
          ProfileRouteEnum.ADDUSER,
        ]),
        permissionIds: [EnumPermissions.InvitationGet],
      },
      {
        label: ProfileRouteEnum.MYPRIZE,
        link: makeRoute([
          FeatureRouteEnum.PROFILE,
          ProfileRouteEnum.CABINET,
          ProfileRouteEnum.MYPRIZE,
        ]),
        permissionIds: [EnumPermissions.AchievmentGet],
      },
    ],
  },
  {
    label: 'olympics',
    icon: 'icon-olymp',
    link: makeRoute([FeatureRouteEnum.OLYMPIAD]),
    permissionIds: [EnumPermissions.OlympiadGet],
  },
  {
    label: 'application',
    icon: 'icon-application',
    link: makeRoute([FeatureRouteEnum.APPLICATIONS]),
    permissionIds: [
      EnumPermissions.ApplicationViewAll,
      EnumPermissions.ApplicationViewRegion,
      EnumPermissions.ApplicationViewDistrict,
      EnumPermissions.ApplicationViewOrganization,
    ],
  },
  {
    label: 'application_group',
    icon: 'icon-application',
    link: makeRoute([FeatureRouteEnum.APPLICATION_GROUP]),
    permissionIds: [
      EnumPermissions.GroupPermissionsValidate,
      EnumPermissions.GroupPermissionsViewAll,
      EnumPermissions.GroupPermissionsViewRegion,
      EnumPermissions.GroupPermissionsViewDistrict,
      EnumPermissions.GroupPermissionsViewOrganization,
    ],
  },
  {
    label: 'olympiad_team_formation',
    icon: 'icon-application',
    link: makeRoute([FeatureRouteEnum.OLYMPIAD_TEAM]),
    permissionIds: [
      EnumPermissions.AdvancedEngineeringOlympiadGet,
      EnumPermissions.AdvancedEngineeringOlympiadTeamCreate,
    ],
  },
  {
    label: 'step_to_invention_projects',
    icon: 'icon-application',
    link: makeRoute([FeatureRouteEnum.STEP_TO_INVENTION]),
    permissionIds: [EnumPermissions.StepToInventionProjectUserMenu],
  },
  {
    label: 'special_users',
    icon: 'pi pi-users',
    link: makeRoute([FeatureRouteEnum.SPECIAL_USERS]),
    permissionIds: [
      EnumPermissions.ParticipantGet,
      EnumPermissions.ParticipantViewRegion,
      EnumPermissions.ParticipantViewDistrict,
      EnumPermissions.ParticipantViewOrganization,
    ],
  },
  {
    label: 'appeal',
    icon: 'icon-appeal',
    link: makeRoute([FeatureRouteEnum.APPELLATION]),
    permissionIds: [EnumPermissions.AppellationGet],
  },
  {
    label: 'result',
    icon: 'icon-result',
    link: makeRoute([FeatureRouteEnum.RESULTS]),
    permissionIds: [
      EnumPermissions.StageResultGet,
      EnumPermissions.StageResultViewAll,
      EnumPermissions.StageResultViewRegion,
      EnumPermissions.StageResultViewDistrict,
    ],
  },
  {
    label: 'demo_tests',
    icon: 'icon-test',
    link: makeRoute([FeatureRouteEnum.DEMO_TESTS]),
    permissionIds: [EnumPermissions.DemoTestView],
  },
  // {
  //   label: 'task',
  //   icon: 'icon-task',
  // },
  // {
  //   label: 'usableinfo',
  //   icon: 'icon-book',
  // },
  // {
  //   label: 'olymp-test',
  //   icon: 'icon-test',
  // },
  // {
  //   label: 'appeal',
  //   icon: 'icon-appeal',
  // },
  // {
  //   label: 'announce',
  //   icon: 'icon-announce',
  // },
];
